import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import LeftNav from "./LeftNav";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import { useUsers } from "../../hooks/useUsers";
import { useDispatch } from "react-redux";
import { setUserPermissions } from "../../store/slices/commonSlice";
import { AppBar, Drawer, IconButton, Toolbar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Loader from "../common/Loader/Loader";
import { hideLoader, showLoader } from "../../store/slices/loaderSlice";

const drawerWidth = 226;

const Layout: React.FunctionComponent<any> = () => {
  const dispatch = useDispatch();
  const { getAllUIPermissions, uIPermissionData, uIPermissionIsSuccess,uIPermissionIsLoading } =
    useUsers();

  useEffect(() => {
    getAllUIPermissions({});
  }, []);
  useEffect(() => {
    if (uIPermissionIsSuccess) {
      dispatch(setUserPermissions(uIPermissionData));
    }
  }, [uIPermissionData, uIPermissionIsSuccess]);

  useEffect(()=>{
    if(uIPermissionIsLoading){
      dispatch(showLoader())
    }else{
      dispatch(hideLoader())
    }
  },[uIPermissionIsLoading])

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const drawer = (
    <div className="leftNavWrap">
      <LeftNav />
    </div>
  );

  return (
    <>
    <Loader/>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          elevation={0}
          position="fixed"
          sx={{
            width: { md: `calc(100% - ${drawerWidth}px)` },
            ml: { md: `${drawerWidth}px` },
            background: "#e5eaf5",
          }}
        >
          <Toolbar variant="dense">
            <IconButton
              color="primary"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { md: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <Header />
          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{
            width: { md: drawerWidth },
            flexShrink: { md: 0 },
          }}
          aria-label="Application Left Menu"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            // container={container}
            variant="temporary"
            open={mobileOpen}
            onTransitionEnd={handleDrawerTransitionEnd}
            onClose={handleDrawerClose}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { sm: "block", md: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { sm: "none", md: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { md: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default Layout;
